import { Delete } from "lucide-react";
import { cn } from "@/lib/utils";

export const NumPad = ({ value, onChange, decimals = 0, max = 9, testId = "numpad" }) => {
  const press = (k) => {
    if (k === "C") return onChange("");
    if (k === "⌫") return onChange(value.slice(0, -1));
    if (k === ",") { if (decimals > 0 && !value.includes(".")) onChange((value || "0") + "."); return; }
    if (value.includes(".") && value.split(".")[1].length >= decimals) return;
    if (value.replace(".", "").length >= max) return;
    onChange(value === "0" ? k : value + k);
  };
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={testId}>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, decimals > 0 ? "," : "C", 0, "⌫"].map((k) => (
        <button key={k} type="button" onClick={() => press(String(k))} data-testid={`${testId}-key-${k === "⌫" ? "back" : k === "," ? "dot" : k}`}
          className={cn("h-14 rounded-sm border font-mono text-2xl font-semibold transition-colors active:scale-[0.97]",
            typeof k === "number" ? "bg-secondary border-border hover:bg-accent" : "bg-muted/40 border-border text-muted-foreground hover:text-foreground")}>
          {k === "⌫" ? <Delete className="h-6 w-6 mx-auto" /> : k}
        </button>
      ))}
      {decimals > 0 && <button type="button" onClick={() => press("C")} data-testid={`${testId}-key-C`} className="col-span-3 h-10 rounded-sm border border-border bg-muted/40 text-muted-foreground font-mono text-sm hover:text-foreground">Effacer</button>}
    </div>
  );
};
